import { render } from "./AirportTrafficBlogs.vue?vue&type=template&id=624ee0a0&scoped=true"
import script from "./AirportTrafficBlogs.vue?vue&type=script&lang=js"
export * from "./AirportTrafficBlogs.vue?vue&type=script&lang=js"

import "./AirportTrafficBlogs.vue?vue&type=style&index=0&id=624ee0a0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624ee0a0"]])

export default __exports__